import GoogleChart from "../../../../../components/googleChart/googleChart";
import {connect} from "react-redux";

export default connect(state => ({
  chartName: "attendance_active_clients_table_chart",
  width: "1350px",
  // height: 300,
  chartType: "Table",
  rows: state.activeClientsReducer.tableChartData.data_table.rows,
  columns: state.activeClientsReducer.tableChartData.data_table.cols,
  listeners: state.activeClientsReducer.tableChartData.listeners,
  options: state.activeClientsReducer.tableChartData.options,
  enableEventListeners: false,
  showCurrency: false
}))(GoogleChart);
